<div class="message-list-panel">
  <div class="govuk-inset-text" *ngIf="!folderId">Vyberte priečinok vľavo.</div>
  <p class="govuk-hint" *ngIf="loading()">Načítavam správy…</p>

  <div class="govuk-error-summary" role="alert" *ngIf="error()">
    <div class="govuk-error-summary__body">
      <p class="govuk-body">{{ error() }}</p>
    </div>
  </div>

  <p class="govuk-hint govuk-!-margin-bottom-2" aria-live="polite" *ngIf="!loading() && totalCount() > 0">
    Zobrazené {{ rangeStart() }}–{{ rangeEnd() }} z {{ totalCount() }} · Strana {{ page() }} / {{ pages() }}
  </p>

  <div *ngIf="!loading() && headers().length" class="app-list-container">
    <ul class="govuk-list govuk-!-margin-bottom-0">
      <li *ngFor="let m of headers()" class="app-item govuk-!-padding-2" [class.app-item--selected]="isSelected(m)">
        <div class="app-message-title" 
             (click)="openMessage(m.IdMessage, m.Class)"
             [attr.role]="'button'"
             [attr.tabindex]="0"
             [attr.aria-current]="isSelected(m) ? 'page' : null"
             [attr.aria-label]="ariaLabelFor(m)"
             (keydown.enter)="openMessage(m.IdMessage, m.Class)"
             (keydown.space)="openMessage(m.IdMessage, m.Class); $event.preventDefault()">
          {{ m.Title || 'Bez predmetu' }}
        </div>
        <div class="govuk-hint app-hint govuk-!-margin-top-1">
          {{ displaySender(m) }}
          <span *ngIf="m.DateDelivery" class="date-with-icon">
            <img src="assets/icons/calendar.svg" class="calendar-icon" width="14" height="14" alt="" aria-hidden="true">
            {{ m.DateDelivery | dotNetToDate | date:'d.M.yyyy HH:mm' }}
          </span>
        </div>
        <strong *ngIf="statusTag(m) as tag" class="govuk-tag govuk-!-margin-top-1">
          {{ tag.text }}
        </strong>
      </li>
    </ul>
  </div>

  <div class="govuk-inset-text" *ngIf="!loading() && headers() && headers().length === 0">
    V tomto priečinku sa nenachádzajú žiadne správy.
  </div>

  <nav *ngIf="!loading() && totalCount() > 0" class="app-pagination govuk-!-margin-top-3" role="navigation"
    aria-label="Stránkovanie">

    <button type="button" class="app-pagination__button" 
            [disabled]="!canGoFirst()" 
            (click)="firstPage()" 
            title="Prvá strana">
      ««
    </button>

    <button type="button" class="app-pagination__button" 
            [disabled]="!canPrev()" 
            (click)="prevPage()" 
            title="Predchádzajúca strana">
      «
    </button>

    <div class="app-pagination__numbers">
      <ng-container *ngFor="let p of pagesArray()">
        <button *ngIf="p !== '...'" 
                type="button" 
                class="app-pagination__number" 
                [class.app-pagination__number--current]="p === page()"
                (click)="gotoPage($any(p))">
          {{ p }}
        </button>
        <span *ngIf="p === '...'" class="app-pagination__ellipsis">...</span>
      </ng-container>
    </div>

    <button type="button" class="app-pagination__button" 
            [disabled]="!canNext()" 
            (click)="nextPage()" 
            title="Ďalšia strana">
      »
    </button>

    <button type="button" class="app-pagination__button" 
            [disabled]="!canGoLast()" 
            (click)="lastPage()" 
            title="Posledná strana">
      »»
    </button>
  </nav>
</div>